interface State {
  [key: string]: boolean;
  areUnauthedFlagsLoaded: boolean;
}

const state: State = {
  areUnauthedFlagsLoaded: false
};

const getters = {
  getUnauthedFeatureFlags: (state: State) => {
    return state;
  }
};

const mutations = {
  updateUnauthedFeatureFlag(state: State, payload: { flag: string; value: boolean }) {
    state[payload.flag] = payload.value;
  },
  updateAreUnauthedFlagsLoaded(state: State, value: boolean) {
    state.areUnauthedFlagsLoaded = value;
  }
};

const actions = {};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
